import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {HttpService} from './http.service';

@Injectable({
  providedIn: 'root'
})
export class TsExportService extends HttpService {

  download(request: {month: number, year: number}): Observable<Blob>{
    return this.post('ts_export', request, 'blob');
  }
}
